import { createTheme } from "@material-ui/core";

const theme = createTheme({
});

export default theme;